import { useState } from 'react';
import clockIcon from '../assets/icons/clock_icon.png'
import { btnOne, btnOneLight, subTitle } from '../utils/style';
import CertificationRequestForm from '../forms/CertificationRequestForm';

function TrainingCard({ id, image, title, lessons, duration, requestTraining }) {
    const [ showModal, setShowModal ] = useState(false);

    return(
        <div key={id} className=''>
            <div className='bg-customTwo p-4 rounded-lg'>
                <div className='flex justify-center'>
                    <img src={image} height={150} width={150}/>
                </div>
                <div className={subTitle}>{title}</div>
                <div className='text-md text-gray-500 py-2'>{`(${lessons} Lessons)`}</div>
                <div className='flex py-2'>
                    <div className={btnOneLight}>
                        <img src={clockIcon}/>
                        <div className='ml-2 text-sm font-semibold'>{duration}</div>
                    </div>
                </div>
                <div className='py-2'>
                    <button className={btnOne} onClick={() => setShowModal(true)}>Request</button>
                </div>
            </div>
            {
                showModal &&
                <CertificationRequestForm setShowModal={setShowModal} submitHandler={() => {requestTraining(id);setShowModal(false)}} image={image} courseTitle={title} />
            }
        </div>
    )
}
export default TrainingCard;